var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var get = function (getter, fallback) {
    try {
        var val = getter();
        return val !== void 0 ? val : fallback;
    }
    catch (e) {
        return fallback;
    }
};
export var omit = function (key) { return function (obj) {
    var _a = obj, _b = key, _v = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    return rest;
}; };
export var omitMedia = omit('media');
export var isoDateFromTimestamp = function (timestamp) {
    timestamp = Number(timestamp);
    if (isNaN(timestamp)) {
        return null;
    }
    return new Date(timestamp).toString();
};
export var createWixCodeDateTimeObject = {
    fromISODate: function (ISODate) { return ({ $date: ISODate }); },
    fromTimestamp: function (timestamp) {
        timestamp = Number(timestamp);
        if (isNaN(timestamp)) {
            return null;
        }
        return createWixCodeDateTimeObject.fromISODate(new Date(timestamp).toString());
    },
};
export var getString = function (item) {
    // standard way of checking undefined/null (and not 0)
    // tslint:disable-next-line: triple-equals
    return item != null && item.toString ? item.toString() : null;
};
//# sourceMappingURL=utils.js.map